export default __webpack_public_path__ + "static/options-722e40a8793432178cad30f2bfc19a49.jpg";